import { render, staticRenderFns } from "./orderTenderCard.vue?vue&type=template&id=0acd2ef1&scoped=true"
import script from "./orderTenderCard.vue?vue&type=script&lang=js"
export * from "./orderTenderCard.vue?vue&type=script&lang=js"
import style0 from "./orderTenderCard.vue?vue&type=style&index=0&id=0acd2ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd2ef1",
  null
  
)

export default component.exports